module.exports = __webpack_public_path__ + "static/img/entrepreneur-propile-img.0a3934bf.svg";